import { render, staticRenderFns } from "./CurriculumUpload.vue?vue&type=template&id=0e46b559&"
import script from "./CurriculumUpload.vue?vue&type=script&lang=ts&"
export * from "./CurriculumUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports